import DeviceUtils from '../../../shared/utils/device';
import IDevice from '../../../shared/types/interfaces/device';
import Storage from '@storage';
import checkLoginRequest from '../../../shared/api/login/checkLoginRequest';
import getVersion from './getVersion';
import { PlayerType } from '@shared/types/enums/player';
import { store } from '@shared/store/store';
import {
  disableNetwork,
  disableVisibility,
  enableNetwork,
  enableVisibility,
} from '../../../shared/store/slices/app.slice';
import getVersionFromUserAgent from '../utils/getVersionFromUserAgent';

class DeviceConfigClass implements IDevice {
  advertisement: { ifaId: string; ifaType: string; limitAdTracking: boolean };
  capabilities: {
    balancer: boolean;
    magicRemote: boolean;
    disableAnimations: boolean;
    disableBlur: boolean;
    exitFromMenu: boolean;
    repeatSelect: boolean;
    disableAds: {
      prerolls: boolean;
      default: boolean;
    };
    image: {
      disableFitCover: boolean;
    };
    minimumCBCSVersion?: number;
  };
  info: {
    language: string;
    make: string;
    model: string;
    os: string;
    platform: string;
    uuid: string;
    version: string | number;
    analyticsPlatform: string;
    adsPlatform: string;
  };
  seller: { bundleId: string; storeUrl: string };
  sourcepoint?: {
    GDPR_PM_ID?: number;
    GDPR_OTT_ID?: number;
    GDPR_LEGACY_OTT_ID?: number;
    USP_OTT_ID?: number;
    USP_LEGACY_OTT_ID?: number;
  };
  getReferer?: () => string;
  exit: () => void;
  checkNetwork: () => boolean;
  defaultDashPlayer?: PlayerType | null;
  defaultHLSPlayer?: PlayerType | null;
  defaultFallbackPlayer?: PlayerType | null;

  constructor() {
    this.advertisement = {
      ifaId: '',
      ifaType: '',
      limitAdTracking: false,
    };

    this.capabilities = {
      balancer: true,
      magicRemote: true,
      exitFromMenu: true,
      disableAnimations: false,
      disableAds: {
        prerolls: true,
        default: false,
      },
      disableBlur: false,
      repeatSelect: true,
      image: {
        disableFitCover: false,
      },
    };

    this.info = {
      language: window.navigator.language || '',
      make: 'Browser',
      model: Storage.get('model') || 'browser_' + getVersion() || '',
      os: 'Browser',
      platform: 'SMARTTV',
      analyticsPlatform: 'LG',
      adsPlatform: 'LG',
      uuid: Storage.get('device') || DeviceUtils.getUUID(),
      version: getVersion() || '',
    };

    this.seller = {
      bundleId: '3202103023117',
      storeUrl: '',
    };

    this.sourcepoint = {
      GDPR_PM_ID: 1205974,
    };

    // Device functions

    this.exit = () => window.close();

    // Update storage

    Storage.set('device', this.info.uuid);
    Storage.set('model', this.info.model);

    window.addEventListener('online', () => store.dispatch(enableNetwork()));
    window.addEventListener('offline', () => store.dispatch(disableNetwork()));

    this.checkNetwork = () => {
      return navigator.onLine;
    };

    // Check login logic

    setTimeout(() => {
      checkLoginRequest();
    });

    window.onload = () => {
      let visibilityChange = '';

      if (typeof document.hidden !== 'undefined') {
        visibilityChange = 'visibilitychange';
      } else if (typeof document?.webkitHidden !== 'undefined') {
        visibilityChange = 'webkitvisibilitychange';
      }
      document.addEventListener(visibilityChange, function () {
        if (document.hidden) {
          store.dispatch(disableVisibility());
        } else {
          store.dispatch(enableVisibility());
        }
      });
    };
  }

  getConnectionType = () => {
    return 'Wi-Fi';
  };
  getBrowser = () => {
    return 'Google Chrome';
  };
  getBrowserVersion = () => {
    return `Chrome ${getVersionFromUserAgent() || 'Unknown'}`;
  };
  getDeviceType = () => {
    return 'TV';
  };
  getDeviceModel = () => {
    return navigator.userAgent;
  };
  getDeviceVendor = () => {
    return 'LG';
  };
  getOs = () => {
    return 'WebOS';
  };
  getOsVersion = () => {
    return 'WebOS 6.0';
  };
}

const DeviceConfig = new DeviceConfigClass();

export default DeviceConfig;
